import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const CANONICAL_BASE = "https://rootedbusinessadvisors.com";

export function SEO({ title, description }) {
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = title;
    const tag = document.querySelector('meta[name="description"]');
    if (tag) tag.setAttribute("content", description);

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", `${CANONICAL_BASE}${pathname === "/" ? "/" : pathname}`);
  }, [title, description, pathname]);

  return null;
}
